import { API_URL } from '../../../app-config/constants';
import ReviewCycleListDto from '../../../types/ReviewCycleListDto';
import { get } from '../request';

const REVIEW_CYCLE_V2_PATH = `${API_URL}/review-cycle`;

getCycles.operation = 'READ';
export function getCycles(reviewerIds: { mainReviewerId: string; contributingReviewerId: string }) {
    return get<ReviewCycleListDto[]>(REVIEW_CYCLE_V2_PATH + '?' + encodeData(reviewerIds));
}

function encodeData(data: Record<string, string>) {
    return Object.keys(data)
        .map(key => [key, data[key]].map(encodeURIComponent).join('='))
        .join('&');
}
